export const getGoogleRedirectUrl = (
  latitude: number,
  longitude: number,
  destaination: string
) => {
  return `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${destaination}&travelmode=driving`;
};

export const EVENT_LISTING_MSG = {
  GEO_LOCATION_NOT_SUPPORTED_MSG:
    'Geolocation is not supported by this browser.',
  LINK_URL_PATTERN:
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi,
  EVENT_HEADING: 'EVENT_HEADING',
  EVENT_TYPE: 'upcoming',
  MY_EVENT: 'Events',
  EVENTS: 'Events',
  EVENT: 'Event',
  VIEW_LESS: 'VIEW LESS',
  VIEW_MORE: 'VIEW MORE',
  EVENT_CALENDAR: 'Event Calendar',
  NO_EVENT_AVAILABLE: 'You have not added or synced any events yet',
  NO_EVENT_FOUND: 'No events found',
  NO_PASSED_EVENTS: 'No Past Events',
  EVENT_SET_MSG:
    'Please add an active event to enable event calender on your TopFan site',
  Events: 'Events',
  EVENT_IMPORT_FROM_BANDSIN: 'Event imported from Bandsintown',
  TICKETS: 'Tickets',
  EVENTS_TICKETING: 'Event Ticketing',
  MANAGE_NATIVE_TICKETS: 'Manage Native Tickets',
  UNLOCK_SUBSCRIBE_EXTERNAL_TICKETS: 'To Buy an External Ticket You Must Be a Subscriber',
  UNLOCK_SUBSCRIBE_TICKET_CONTENT: 'To unlock this ticket, you must be a Subscriber',
  ONLINE: 'Online',
  ATTENDING: 'Attending',
  JOIN: 'Join',
  ENROLL: 'Enroll',
  LIVE: 'live',
  LIVE_ONLINE_LESSON: 'Live Online Lesson'
};

export const EVENT_EXTERNAL_TICKET_LOCK = {
  labels: {
    UNLOCK_OPTIONS_HEADER: 'Unlock External Tickets',
    UNLOCK_OPTIONS_DESCRIPTION:
      'This external ticket link is only available to Subscribers or NFT Holders.',
    SUBSCRIBE: 'SUBSCRIBE',
    NFT: 'NFT',
    OR: 'or'
  }
} as const;

export enum EVENT_ELEMENT {
  ACTIVE_ELEMENT = 'Active Events',
  PASSED_EVENTS = 'Past Events'
}

export enum EVENT_TYPE {
  UPCOMING = 'upcoming',
  PASSED = 'past'
}

export interface IVENUEDETAILS {
  event_name: string;
  venue_name: string;
  event_time: string;
  timezone: string;
  city: string;
  country: string;
  street_address: string;
  postal_code?: string;
  state: string;
  sk: string;
  view_more: boolean;
  ticket_type?: string;
  /** API: event list / calendar rows */
  preview_image_url?: string;
  event_date?: string;
  more_info?: string;
  ticket_url?: string;
  vip_url?: string;
  vip_code1?: string | null;
  vip_code2?: string | null;
  cta_1?: string;
  cta_2?: string;
  bandsintown?: boolean;
  pk?: string;
  display_upcoming_countdown?: boolean;
  event_format?: string;
  ticket_price?: number;
  meeting_provider?: string;
  display_attendee_list?: boolean;
  optional_instruction?: string;
  loyalty_points?: number;
  international_prices?: unknown[];
  latitude?: number | null;
  longitude?: number | null;
  external_locked_through?: {
    subscription?: Array<{ sk: string; pk: string; title?: string }>;
    nft?: string[];
  };
  external_lock_status?: {
    is_unlocked?: boolean;
    unlocked_by?: string;
  };
  course?: { pk: string; sk: string };
  lesson?: { pk: string; sk: string };
  is_locked?: boolean;
  user?: { user_name?: string; gsi4pk?: string };
}

export interface ILessonCountdownDetails {
  preview_image_url?: string;
  event_date: string;
  event_time: string;
  timezone: string;
  event_name: string;
  more_info?: string;
  type: string;
  course: { pk: string; sk: string };
  lesson: { pk: string; sk: string };
  is_locked: boolean;
}

export type UpcomingCountdownData = IVENUEDETAILS | ILessonCountdownDetails;

export interface IOTHEREVENTDETAILS {
  event_calendar_image_url: string;
  sk: string;
  event_calendar_name: string;
  pk: string;
  heading: string;
  display_event_calendar: boolean;
}
export const convertUrlsToLinks = (text: string): string => {
  const urlPattern = EVENT_LISTING_MSG.LINK_URL_PATTERN;
  return text.replace(
    urlPattern,
    '<a class="links" href="$1" target="_blank">$1</a>'
  );
};
